<div aria-live="polite" class="hx-table-empty-state" role="status">
  <div aria-hidden="true">
    <svg width="250" height="255" viewBox="0 0 250 255" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M125 250C194.036 250 250 194.036 250 125C250 55.9644 194.036 0 125 0C55.9644 0 0 55.9644 0 125C0 194.036 55.9644 250 125 250Z"
        fill="#E0EFF1" />
      <g filter="url(#filter0_d_479_8262)">
        <mask
          id="mask0_479_8262"
          style="mask-type: alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="250"
          height="250">
          <path
            d="M125 250C194.036 250 250 194.036 250 125C250 55.9644 194.036 0 125 0C55.9644 0 0 55.9644 0 125C0 194.036 55.9644 250 125 250Z"
            fill="#A2D0D6" />
        </mask>
        <g mask="url(#mask0_479_8262)">
          <path
            d="M196.667 71.6667H53.3333C48.731 71.6667 45 75.3976 45 80V255C45 259.602 48.731 263.333 53.3333 263.333H196.667C201.269 263.333 205 259.602 205 255V80C205 75.3976 201.269 71.6667 196.667 71.6667Z"
            fill="#FDFDFD" />
        </g>
      </g>
      <path
        d="M110 88.3333H66.6666C63.9052 88.3333 61.6666 90.5719 61.6666 93.3333C61.6666 96.0947 63.9052 98.3333 66.6666 98.3333H110C112.761 98.3333 115 96.0947 115 93.3333C115 90.5719 112.761 88.3333 110 88.3333Z"
        fill="#E0EFF1" />
      <path
        d="M110 158.333H66.6666C63.9052 158.333 61.6666 160.572 61.6666 163.333C61.6666 166.095 63.9052 168.333 66.6666 168.333H110C112.761 168.333 115 166.095 115 163.333C115 160.572 112.761 158.333 110 158.333Z"
        fill="#E0EFF1" />
      <path
        d="M180 113.333H69.9999C66.318 113.333 63.3333 116.318 63.3333 120V136.667C63.3333 140.349 66.318 143.333 69.9999 143.333H180C183.682 143.333 186.667 140.349 186.667 136.667V120C186.667 116.318 183.682 113.333 180 113.333Z"
        stroke="#64B1BB"
        stroke-width="3.33333" />
      <path
        d="M180 181.667H70C65.3976 181.667 61.6666 185.398 61.6666 190V203.333C61.6666 207.936 65.3976 211.667 70 211.667H180C184.602 211.667 188.333 207.936 188.333 203.333V190C188.333 185.398 184.602 181.667 180 181.667Z"
        fill="#E0EFF1" />
      <path
        d="M170 156.667C174.602 156.667 178.333 152.936 178.333 148.333C178.333 143.731 174.602 140 170 140C165.397 140 161.667 143.731 161.667 148.333C161.667 152.936 165.397 156.667 170 156.667Z"
        fill="#E0EFF1" />
      <path
        d="M176.512 183.95C175.178 183.95 173.933 183.95 172.8 183.878C171.404 183.784 170.061 183.306 168.919 182.498C167.777 181.69 166.88 180.582 166.327 179.297L159.295 165.4C158.779 164.8 158.522 164.02 158.579 163.23C158.635 162.441 159.002 161.705 159.598 161.185C160.087 160.792 160.696 160.581 161.323 160.587C161.785 160.6 162.238 160.713 162.651 160.919C163.065 161.124 163.429 161.417 163.718 161.777L166.912 166.135L166.96 166.192V149.633C166.96 148.812 167.286 148.024 167.867 147.443C168.448 146.862 169.236 146.536 170.057 146.536C170.879 146.536 171.667 146.862 172.248 147.443C172.829 148.024 173.155 148.812 173.155 149.633V160.467C173.119 160.068 173.166 159.666 173.294 159.287C173.422 158.908 173.628 158.559 173.898 158.264C174.168 157.968 174.496 157.732 174.863 157.571C175.229 157.409 175.625 157.326 176.025 157.326C176.425 157.326 176.821 157.409 177.187 157.571C177.554 157.732 177.882 157.968 178.152 158.264C178.422 158.559 178.628 158.908 178.756 159.287C178.883 159.666 178.931 160.068 178.895 160.467V162.725C178.859 162.326 178.906 161.925 179.034 161.545C179.162 161.166 179.368 160.818 179.638 160.522C179.908 160.227 180.236 159.991 180.603 159.829C180.969 159.668 181.365 159.584 181.765 159.584C182.165 159.584 182.561 159.668 182.927 159.829C183.294 159.991 183.622 160.227 183.892 160.522C184.162 160.818 184.368 161.166 184.496 161.545C184.623 161.925 184.671 162.326 184.635 162.725V164.465C184.599 164.066 184.646 163.665 184.774 163.285C184.902 162.906 185.108 162.558 185.378 162.262C185.648 161.967 185.976 161.731 186.343 161.569C186.709 161.408 187.105 161.324 187.505 161.324C187.905 161.324 188.301 161.408 188.667 161.569C189.034 161.731 189.362 161.967 189.632 162.262C189.902 162.558 190.108 162.906 190.236 163.285C190.363 163.665 190.411 164.066 190.375 164.465V175.027C190.318 178.275 188.85 183.752 183.685 183.752C183.31 183.768 180.133 183.952 176.518 183.952L176.512 183.95Z"
        fill="#64B1BB"
        stroke="#FDFDFD"
        stroke-width="1.66667" />
      <circle
        cx="3.80909"
        cy="3.80909"
        r="3.80909"
        transform="matrix(-1 0 0 1 82.1422 120)"
        stroke="#64B1BB"
        stroke-width="1.66667" />
      <path
        d="M71.6665 133.272C71.6665 132.452 72.1815 131.721 72.9531 131.446C76.4317 130.204 80.2331 130.204 83.7117 131.446C84.4833 131.721 84.9983 132.452 84.9983 133.272V134.524C84.9983 135.655 83.9968 136.524 82.8774 136.364L82.5042 136.31C79.737 135.915 76.9278 135.915 74.1606 136.31L73.7874 136.364C72.668 136.524 71.6665 135.655 71.6665 134.524V133.272Z"
        stroke="#64B1BB"
        stroke-width="1.66667" />
      <defs>
        <filter
          id="filter0_d_479_8262"
          x="35"
          y="56.6667"
          width="180"
          height="198.333"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha" />
          <feOffset dy="-5" />
          <feGaussianBlur stdDeviation="5" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_479_8262" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_479_8262" result="shape" />
        </filter>
      </defs>
    </svg>
  </div>

  <p class="message">{{ message() }}</p>
</div>
